import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Activity } from './activity';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { ParameterValue } from '../base/parameter-value';
import { Office365EmailLinkedService } from '../linkedservice/office365-email.linkedservice';
import { LinkedService } from '../linkedservice/linkedservice';
import { format } from '../../shared/utils/string.util';
import { Copier } from '../base/copier';
import { GlobalVariables } from '../../constants/globals';

@Metamodel.model({
    name: ModelConstants.office365EmailActivity,
    referable: true
})
export class Office365EmailActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly TO: IAttribute;
    public static readonly SUBJECT: IAttribute;
    public static readonly BODY: IAttribute;
    public static readonly FROM: IAttribute;
    public static readonly CC: IAttribute;
    public static readonly BCC: IAttribute;
    public static readonly SENSITIVITY: IAttribute;
    public static readonly REPLY_TO: IAttribute;
    public static readonly IMPORTANCE: IAttribute;
    public static readonly UPN: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ConnectionLabel,
        reference: true,
        type: Office365EmailLinkedService.MODEL,
        constraint: {
            validator: Office365EmailActivity.validateConnection
        }
    })
    public office365EmailConnection: Office365EmailLinkedService;

    @Metamodel.attribute({
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[] = [];

    @Metamodel.attribute({
        display: shellStringResources.To_Label,
        association: 'TO',
        constraint: {
            required: true
        },
        templatable: true
    })
    public to: string;

    @Metamodel.attribute({
        display: shellStringResources.Subject,
        association: 'SUBJECT',
        constraint: {
            required: true
        },
        templatable: true
    })
    public subject: string;

    @Metamodel.attribute({
        display: shellStringResources.Body_Label,
        association: 'BODY',
        constraint: {
            required: true
        },
        templatable: true
    })
    public body: string;

    @Metamodel.attribute({
        display: shellStringResources.From_Send_As_Label,
        association: 'FROM',
        templatable: true
    })
    public from?: string;

    @Metamodel.attribute({
        display: shellStringResources.CC_Label,
        association: 'CC',
        templatable: true
    })
    public cc?: string;

    @Metamodel.attribute({
        display: shellStringResources.BCC_Label,
        association: 'BCC',
        templatable: true
    })
    public bcc?: string;

    @Metamodel.attribute({
        display: shellStringResources.Sensitivity_Label,
        association: 'SENSITIVITY',
        templatable: true
    })
    public sensitivity?: string;

    @Metamodel.attribute({
        display: shellStringResources.Reply_To_Label,
        association: 'REPLY_TO',
        templatable: true
    })
    public replyTo?: string;

    @Metamodel.attribute({
        display: shellStringResources.Importance_Label,
        association: 'IMPORTANCE',
        templatable: true
    })
    public importance?: string;

    @Metamodel.attribute({
        display: shellStringResources.OnBehalfOfUser_Label,
        association: 'UPN',
        templatable: true
    })
    public upn?: string;

    private static validateConnection(_office365EmailActivity?: Office365EmailActivity, connection?: LinkedService): IViolation[] | undefined {
        if (!connection) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.ConnectionLabel)
                }
            ];
        } else if (connection && connection.getLinkedServiceType() != Metamodel.modelFor(Office365EmailLinkedService).name) {
            return [
                {
                    message: () =>
                        format(
                            shellStringResources.ActivityNotSupportLinkedServiceError,
                            format(shellStringResources.ModelName_ActivityTemplate, shellStringResources.Office365Email_Label),
                            format(shellStringResources.ModelName_ConnectionTemplate, Metamodel.modelOf(connection).name)
                        ),
                    messageType: 'unsupported'
                }
            ];
        }
        return undefined;
    }

    public onActivityCloned(clonedActivity: Office365EmailActivity, context: { inlineDataset?: boolean }): void {
        if (GlobalVariables.isTrident) {
            if (this.office365EmailConnection?.parameterized) {
                clonedActivity.office365EmailConnection = Copier.clone(
                    context,
                    [this.office365EmailConnection],
                    undefined,
                    true
                )[0] as Office365EmailLinkedService;
            }
        }
    }
}